import { render, staticRenderFns } from "./DatePicker.vue?vue&type=template&id=4ccb5234&"
import script from "./DatePicker.vue?vue&type=script&lang=js&"
export * from "./DatePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/christoph/workspace/nextcloud/apps/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ccb5234')) {
      api.createRecord('4ccb5234', component.options)
    } else {
      api.reload('4ccb5234', component.options)
    }
    module.hot.accept("./DatePicker.vue?vue&type=template&id=4ccb5234&", function () {
      api.rerender('4ccb5234', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/DatePicker.vue"
export default component.exports